export const ActivityIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '19'}
    height={props?.height || '17'}
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4167 8.25H14.0833L11.5833 15.75L6.58333 0.75L4.08333 8.25H0.75"
      stroke={props?.color || '#667085'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
